import {
    Control, FieldValues, useController,
    Path,
} from 'react-hook-form';
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';
import { DatePicker, DatePickerProps } from '../date-picker/date-picker';

export function DatePickerField<TFormValues extends FieldValues>({
    control,
    name,
    label,
    isRequired = false,
    allowClear = true,
    fromDate,
    toDate,
    ...dayPickerProps
}: DatePickerProps & {
    control: Control<TFormValues>;
    name: Path<TFormValues>;
    label: string;
    isRequired?: boolean;
}) {
    const {
        field,
        fieldState: { error, invalid },
    } = useController({
        name,
        control,
    });

    return (
        <FormControl isInvalid={invalid} isRequired={isRequired}>
            <FormLabel>{label}</FormLabel>
            <DatePicker
                {...field}
                allowClear={allowClear}
                placeholder={field.value}
                noDateSelectedText="Select date"
                isInvalid={invalid}
                dateDisplayFormat="do MMMM yyyy"
                size="md"
                fromDate={fromDate}
                toDate={toDate}
                {...dayPickerProps}
            />
            <FormErrorMessage>
                {error && error?.message}
            </FormErrorMessage>
        </FormControl>
    );
}
